import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@mssgme/ui';
import LoadMoreButton from '../LoadMoreButton';
import FilterMessage from '../FilterMessage';

export default function ProductsListFooter({ products, loadMore }) {
    const { t } = useTranslation('cards');

    if (products.isFetching) {
        return <Spinner />;
    }

    const isEmptyCollection = products.items.length === 0;

    return (
        <>
            {products.next && <LoadMoreButton onClick={loadMore} />}

            {isEmptyCollection &&
                (products.filter.name ? (
                    <FilterMessage
                        title={t('pageProducts.filterEmptyHeading')}
                        description={t('pageProducts.filterEmptyDescription')}
                    />
                ) : (
                    <FilterMessage
                        title={t('pageProducts.emptyHeading')}
                        description={t('pageProducts.emptyDescription')}
                    />
                ))}
        </>
    );
}

ProductsListFooter.propTypes = {
    products: PropTypes.shape({
        items: PropTypes.array.isRequired,
        isFetching: PropTypes.bool,
        next: PropTypes.string,
        filter: PropTypes.shape({
            name: PropTypes.string,
        }).isRequired,
    }).isRequired,
    loadMore: PropTypes.func.isRequired,
};
